import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { toggleProcedureVisibility } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

export async function toggleVisibility({
  accountId,
  visibilityStatus,
  procedureIds,
}: TVariables): Promise<TResult> {
  const response = await fetch(
    toggleProcedureVisibility(accountId, visibilityStatus),
    {
      method: 'PUT',
      headers: {
        Authorization: getTokenWithType(),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(procedureIds),
    },
  );
  return response.json();
}

export type TError = ErrorModal;

export type TResult = {
  Data: string;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

export type TVariables = {
  accountId: number;
  visibilityStatus: number;
  procedureIds: Array<number> | null;
};

export type TSnapshot = unknown;

function useUpdateProcedureVisibilty(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(
    async ({ accountId, visibilityStatus, procedureIds }: TVariables) => {
      const updatedVisibility = await toggleVisibility({
        accountId,
        visibilityStatus,
        procedureIds,
      });

      if (updatedVisibility.Data) {
        queryClient.invalidateQueries(
          ['get_procedure_builder_procedures', accountId],
          {
            refetchInactive: true,
          },
        );
        queryClient.invalidateQueries(['get_procedure'], {
          refetchInactive: true,
        });
      } else if (updatedVisibility.Errors) throw updatedVisibility;
      return updatedVisibility;
    },
  );
}

export { useUpdateProcedureVisibilty };
